// TEMP: mock details for the Findings side overlay sections no API covers yet (the Known exploit card, currently
// commented out in OverviewTab). The attack path, resource risks and fix are fetched in OverviewTab. Whatever the
// clicked row carries (CVE, severity) is used as is; the rest is sample data shaped like the response we expect.

const pick = (...values) => values.find(value => value !== undefined && value !== null && value !== '');

export const buildFindingDetails = (row = {}) => {
  const cveId = pick(row.cve_id, 'CVE-2023-34540');
  const severity = pick(row.severity, 'critical')?.toLowerCase();

  return {
    cveId,
    title: pick(row.title, row.cve_title, 'LangChain JiraAPIWrapper Code Execution'),
    severity,

    exploit: {
      maturity: 'Proof of concept',
      cisaKev: false,
      // Mock only: the table's EPSS column shows `exploitability_score`, whose scale is not an EPSS probability.
      epssScore: 0.0412,
      epssPercentile: 0.92,
      publishedAt: '2023-06-14',
      references: [
        { label: 'GitHub advisory GHSA-2wjx-3f6m-rgv5', url: 'https://github.com/advisories/GHSA-2wjx-3f6m-rgv5' },
        { label: 'NVD entry', url: `https://nvd.nist.gov/vuln/detail/${cveId}` },
      ],
    },
  };
};
